import http from '../_http_v2';

const result = {
  //default
  summary: (m) => { return http.get(`console/wsfinder/result`, m); },
  list: (m) => { return http.post(`console/wsfinder/result/list`, m); },
  detail: (m) => { return http.get(`console/wsfinder/result/${m.id}`); },

  //crud
  insert: (m) => { return http.post(`console/wsfinder/result`, m); },
  update: (m) => { return http.put(`console/wsfinder/result`, m); },
  delete: (m) => { return http.delete(`console/wsfinder/result/${m.id}`); },
}

export default result

export { result }